/** @enum {string} */
export const RevenueTypes = {
    /** Use for device, shipping */
    OneTime: 'one-time',
    /** Use for regular or any other subscriptions */
    Subscription: 'subscription'
};


// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/enums/revenueTypes.ts